// The server remains the authority for the exact approved package and its bytes.
export function deliveryErrorCopy(status, code) {
  if (status === 404 && (!code || code === 'delivery_unavailable')) return 'No delivery package is available for this approved build. Reload its current revision.';
  if (status === 409 && code === 'delivery_invalid') return 'The delivery package failed integrity checks. Request package recovery before downloading.';
  if (status === 409 && code === 'canonical_delivery_required') return 'A canonical approved delivery package is required. Reopen the current revision and complete its delivery checks.';
  if (status === 401 || status === 403) return 'You no longer have access to this delivery. Sign in with an authorized workspace account.';
  return 'Delivery download failed' + (status ? ' (' + status + ')' : '') + '. Reload and try again.';
}

export function reviewDeliveryReady({ isLive, currentReviewResult, job, session, dirty, readOnly, pending }) {
  return !!(isLive && !dirty && !readOnly && !pending && session?.revision_digest
    && (currentReviewResult ? currentReviewResult.decision === 'approve'
      : job?.status === 'complete' && job?.verdict === 'PASS' && session.approval_state === 'approved'));
}

export async function downloadReviewDelivery(jobId, { api = window.GooseAPI, fetcher = fetch,
  document: doc = document, urlApi = URL, schedule = setTimeout, isCurrent = () => true } = {}) {
  if (!isCurrent()) return;
  const url = api?.deliveryUrl?.(jobId);
  if (!url) throw new Error('Delivery download is unavailable in this workspace.');
  let response;
  try { response = await fetcher(url, { credentials: 'include' }); }
  catch (_) { throw new Error(deliveryErrorCopy()); }
  if (!isCurrent()) return;
  if (!response.ok) {
    let body;
    try { body = await response.json(); } catch (_) {}
    throw new Error(deliveryErrorCopy(response.status, body?.code || body?.error));
  }
  const blob = await response.blob();
  if (!isCurrent()) return;
  const disposition = response.headers.get('content-disposition') || '';
  const name = disposition.match(/filename="([^"\r\n]+)"/i)?.[1]
    || disposition.match(/filename=([^;\s]+)/i)?.[1] || String(jobId) + '.zip';
  const link = doc.createElement('a'), objectUrl = urlApi.createObjectURL(blob);
  link.href = objectUrl;
  link.download = name.replace(/[\\/\x00-\x1f\x7f]/g, '_');
  try { doc.body.appendChild(link); link.click(); }
  finally { link.remove(); schedule(() => urlApi.revokeObjectURL(objectUrl), 1000); }
}
